import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'
import { translate } from '@/i18n'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  override render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback

      return (
        <div className="flex min-h-screen items-center justify-center bg-surface-950 p-6">
          <div className="max-w-md rounded-2xl border border-surface-800 bg-surface-900 p-8 text-center">
            <p className="mb-2 text-4xl">⚡</p>
            <h1 className="mb-2 text-xl font-semibold text-surface-100">
              {translate('Er is iets misgegaan')}
            </h1>
            <p className="mb-6 text-sm text-surface-400">
              {this.state.error.message}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="rounded-lg bg-accent-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-accent-500"
            >
              {translate('Opnieuw laden')}
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
